// ChooseCategoryContainer.tsx
import type { ReactNode } from 'react';
import { Loader } from '@/_component/Common';
import CategoryList from './components/CategoryList';
import { useChooseCategory } from './hooks/useChooseCategory';
import { ICategoryStrategy } from './strategies/ICategoryStrategy';

type Props = {
  strategy: ICategoryStrategy;
  emptyContent?: ReactNode;
};

export const ChooseCategoryContainer: React.FC<Props> = ({ strategy, emptyContent = null }) => {
  const { categories, loading, handleCategoryClick } = useChooseCategory(strategy);

  if (loading) return <Loader />;
  if (categories.length === 0) return <>{emptyContent}</>;

  return <CategoryList categories={categories} onClick={handleCategoryClick} />;
};
